export const DEMO_PLAYERS_DATA = [
  {
    id: 'usr_eDTnRrmDFNV',
    name: null,
    email: 'demo_08b3aa61@gmail.com',
    player_id: 'demo_08b3aa61',
    created_at: 1724604278,
    modified_at: 1739548412,
    country: 'FR',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-6.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1739223854,
    last_verified_at: 1739223854,
    last_active_at: 1739223854,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 1,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrvHELU',
    name: null,
    email: 'demo_655b2006@gmail.com',
    player_id: 'demo_48b53932',
    created_at: 1724604270,
    modified_at: 1733220244,
    country: 'NL',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-6.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604270,
    last_verified_at: 1724604270,
    last_active_at: 1724604270,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrsNiHH',
    name: null,
    email: 'demo_1fbcfe74@gmail.com',
    player_id: 'demo_a76d5109',
    created_at: 1724604262,
    modified_at: 1739211311,
    country: 'IN',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-9.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604262,
    last_verified_at: 1724604262,
    last_active_at: 1724604262,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrSGAcQ',
    name: null,
    email: 'demo_81b30e44@gmail.com',
    player_id: 'demo_d903d920',
    created_at: 1724604254,
    modified_at: 1735032659,
    country: 'ES',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-10.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604254,
    last_verified_at: 1724604254,
    last_active_at: 1724604254,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrdZlUD',
    name: null,
    email: 'demo_7198015a@gmail.com',
    player_id: 'demo_7198015a',
    created_at: 1724604245,
    modified_at: 1739223136,
    country: 'NL',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-12.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604245,
    last_verified_at: 1724604245,
    last_active_at: 1724604245,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'demo_dbb094ec',
    name: null,
    email: 'demo_7198015a@gmail.com',
    player_id: 'demo_dbb094ec',
    created_at: 1724604245,
    modified_at: 1739223136,
    country: 'NL',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-12.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604245,
    last_verified_at: 1724604245,
    last_active_at: 1724604245,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrbFvik',
    name: null,
    email: 'demo_a44c8e40@gmail.com',
    player_id: 'demo_a44c8e40',
    created_at: 1724604236,
    modified_at: 1739223156,
    country: 'BR',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-11.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604236,
    last_verified_at: 1724604236,
    last_active_at: 1724604236,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRrhjeFF',
    name: null,
    email: 'demo_4b27a520@gmail.com',
    player_id: 'demo_4b27a520',
    created_at: 1724604207,
    modified_at: 1739223172,
    country: 'IT',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-5.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604207,
    last_verified_at: 1724604207,
    last_active_at: 1724604207,
    ltv: 0.0,
    average_check: 0.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
  {
    id: 'usr_eDTnRremSdp',
    name: null,
    email: 'demo_d7e77b01@gmail.com',
    player_id: 'demo_d7e77b01',
    created_at: 1724604099,
    modified_at: 1744045969,
    country: 'US',
    avatar_url: 'https://static.aghanim.com/images/hub/avatars/avatar-4.webp',
    banned: false,
    attributes: {
      level: 0,
      platform: null,
      marketplace: 'none',
      saved_ach: false,
      saved_card: false,
      soft_currency_amount: 0,
      hard_currency_amount: 0,
      appsflyer_id: null,
      appsflyer_app_id: null,
      appsflyer_meta: null,
      adjust_device_id: null,
      adjust_adid: null,
      adjust_callback_params: null,
      adjust_partner_params: null,
      singular_device_id: null,
      singular_app_id: null,
    },
    last_login_at: 1724604224,
    last_verified_at: 1724604224,
    last_active_at: 1724604224,
    ltv: 217.0,
    average_check: 217.0,
    game_hub_login_count: 0,
    banned_reason: null,
    facebook_id: null,
    telegram_id: null,
    apple_id: null,
  },
]
